import { useI18n } from '../context/I18nContext';

export default function ConfirmModal({
  open = false,
  title,
  description,
  confirmLabel,
  cancelLabel,
  danger = true,
  busy = false,
  onCancel,
  onConfirm,
}) {
  const { t } = useI18n();
  const resolvedTitle = title || t('components.confirmModal.title');
  const resolvedDescription =
    description || t('components.confirmModal.description');
  const resolvedConfirmLabel = confirmLabel || t('components.confirmModal.confirm');
  const resolvedCancelLabel = cancelLabel || t('components.confirmModal.cancel');

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center bg-black/45 p-4">
      <div className="w-full max-w-md rounded-2xl border border-[var(--dash-border)] bg-[var(--dash-surface)] p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-[var(--dash-text)]">{resolvedTitle}</h3>
        <p className="mt-2 text-sm text-[var(--dash-text-muted)]">{resolvedDescription}</p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="rounded-lg border border-[var(--dash-border-strong)] px-4 py-2 text-sm text-[var(--dash-text-soft)] hover:bg-[var(--dash-surface-2)] disabled:opacity-50"
          >
            {resolvedCancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-60 ${
              danger
                ? 'bg-[var(--dash-danger)] hover:opacity-90'
                : 'bg-[var(--dash-primary)] hover:bg-[var(--dash-primary-hover)] hover:text-[var(--dash-black)]'
            }`}
          >
            {busy ? t('components.confirmModal.processing') : resolvedConfirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
